import { defineMessages } from "react-intl";

export const messages = defineMessages({
    summaryTitle: {
        id: "fastshift.dashboard.organisation-summary.title",
        defaultMessage: "Migration summary",
        description: "Title for the migration summary section"
    },
    dataCenterProductsAssessedTitle: {
        id: "fastshift.dashboard.organisation-summary.data-center-products-assessed-title",
        defaultMessage:
            "Data Center {assessments, plural, one {product} other {products}} assessed",
        description:
            "Title for Data Center products assessed in the migration summary"
    },
    areasToImprove: {
        id: "fastshift.dashboard.organisation-summary.areas-to-improve-title",
        defaultMessage:
            "{assessments, plural, one {Area} other {Areas}} to improve",
        description: "Title for Areas to improve in the migration summary"
    },
    detectedApps: {
        id: "fastshift.dashboard.organisation-summary.detected-apps-title",
        defaultMessage: "Detected {apps, plural, one {App} other {Apps}}",
        description: "Title for Detected Apps in the migration summary"
    },
    migrationPlansSuccessfullyCompleted: {
        id: "fastshift.dashboard.organisation-summary.migration-plans-successfully-completed-title",
        defaultMessage:
            "Migration {plans, plural, one {plan} other {plans}} successfully completed",
        description:
            "Title for Migration plans successfully completed in the migration summary"
    },
    unsuccessfulMigrationPlans: {
        id: "fastshift.dashboard.organisation-summary.unsuccessful-migration-plans-title",
        defaultMessage:
            "Unsuccessful migration {plans, plural, one {plan} other {plans}}",
        description:
            "Title for Unsuccessful migration plans in the migration summary"
    },
    migrationsRunningCurrently: {
        id: "fastshift.dashboard.organisation-summary.migrations-running-currently-title",
        defaultMessage:
            "{plans, plural, one {Migration} other {Migrations}} running currently",
        description:
            "Title for Migrations running currently in the migration summary"
    },
    viewMigrations: {
        id: "fastshift.dashboard.organisation-summary.view-migrations",
        defaultMessage: "View migrations",
        description: "Button text to view migrations in the migration summary"
    },
    viewAssessments: {
        id: "fastshift.dashboard.organisation-summary.view-assessments",
        defaultMessage: "View assessments",
        description: "Button text to view assessments in the migration summary"
    }
});
